module.exports = __webpack_public_path__ + "static/media/20_potolok_2.71_0.5fe12c65.png";